/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CancelExecutionBody } from "../models/cancelExecutionBody";

import type { CancelExecutionParams } from "../models/cancelExecutionParams";

import type { ExecuteNodesResponse } from "../models/executeNodesResponse";

import type { ExecuteWorkflowNodeMultipartFormDataBody } from "../models/executeWorkflowNodeMultipartFormDataBody";

import type { ExecuteWorkflowNodeRequest } from "../models/executeWorkflowNodeRequest";

import type { ExecuteWorkflowNodeResponse } from "../models/executeWorkflowNodeResponse";

import type { ExecuteWorkflowRequest } from "../models/executeWorkflowRequest";

import type { ReTriggerExecution200 } from "../models/reTriggerExecution200";

import type { RepeatExecutionRequest } from "../models/repeatExecutionRequest";

import type { TriggerWorkflow200 } from "../models/triggerWorkflow200";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Bulk Trigger Workflow
 */
export const bulkTriggerWorkflow = (
  executeWorkflowRequest: ExecuteWorkflowRequest[],
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<string[]>(
    {
      url: `/api/workflow/bulk/trigger`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: executeWorkflowRequest,
      signal,
    },
    options,
  );
};

export const getBulkTriggerWorkflowMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkTriggerWorkflow>>,
    TError,
    { data: ExecuteWorkflowRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkTriggerWorkflow>>,
  TError,
  { data: ExecuteWorkflowRequest[] },
  TContext
> => {
  const mutationKey = ["bulkTriggerWorkflow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkTriggerWorkflow>>,
    { data: ExecuteWorkflowRequest[] }
  > = (props, context) => {
    const { data } = props ?? {};

    return bulkTriggerWorkflow(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkTriggerWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkTriggerWorkflow>>
>;
export type BulkTriggerWorkflowMutationBody = ExecuteWorkflowRequest[];
export type BulkTriggerWorkflowMutationError = ErrorType<unknown>;

/**
 * @summary Bulk Trigger Workflow
 */
export const useBulkTriggerWorkflow = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkTriggerWorkflow>>,
      TError,
      { data: ExecuteWorkflowRequest[] },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkTriggerWorkflow>>,
  TError,
  { data: ExecuteWorkflowRequest[] },
  TContext
> => {
  const mutationOptions = getBulkTriggerWorkflowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Cancel Execution
 */
export const cancelExecution = (
  executionId: string,
  cancelExecutionBody: CancelExecutionBody,
  params?: CancelExecutionParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/workflow/cancel/execution/${encodeURIComponent(String(executionId))}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cancelExecutionBody,
      params,
      signal,
    },
    options,
  );
};

export const getCancelExecutionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelExecution>>,
    TError,
    {
      executionId: string;
      data: CancelExecutionBody;
      params?: CancelExecutionParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelExecution>>,
  TError,
  {
    executionId: string;
    data: CancelExecutionBody;
    params?: CancelExecutionParams;
  },
  TContext
> => {
  const mutationKey = ["cancelExecution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelExecution>>,
    {
      executionId: string;
      data: CancelExecutionBody;
      params?: CancelExecutionParams;
    }
  > = (props, context) => {
    const { executionId, data, params } = props ?? {};

    return cancelExecution(executionId, data, params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelExecution>>
>;
export type CancelExecutionMutationBody = CancelExecutionBody;
export type CancelExecutionMutationError = ErrorType<unknown>;

/**
 * @summary Cancel Execution
 */
export const useCancelExecution = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelExecution>>,
      TError,
      {
        executionId: string;
        data: CancelExecutionBody;
        params?: CancelExecutionParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelExecution>>,
  TError,
  {
    executionId: string;
    data: CancelExecutionBody;
    params?: CancelExecutionParams;
  },
  TContext
> => {
  const mutationOptions = getCancelExecutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Execute Workflow Node
 */
export const executeWorkflowNode = (
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<ExecuteWorkflowNodeResponse>(
    {
      url: `/api/workflow/execute/node`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: executeWorkflowNodeRequest,
      signal,
    },
    options,
  );
};

export const getExecuteWorkflowNodeQueryKey = (
  executeWorkflowNodeRequest?: ExecuteWorkflowNodeRequest,
) => {
  return [`/api/workflow/execute/node`, executeWorkflowNodeRequest] as const;
};

export const getExecuteWorkflowNodeQueryOptions = <
  TData = Awaited<ReturnType<typeof executeWorkflowNode>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExecuteWorkflowNodeQueryKey(executeWorkflowNodeRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof executeWorkflowNode>>
  > = ({ signal, meta }) =>
    executeWorkflowNode(
      executeWorkflowNodeRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof executeWorkflowNode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExecuteWorkflowNodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof executeWorkflowNode>>
>;
export type ExecuteWorkflowNodeQueryError = ErrorType<unknown>;

export function useExecuteWorkflowNode<
  TData = Awaited<ReturnType<typeof executeWorkflowNode>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof executeWorkflowNode>>,
          TError,
          Awaited<ReturnType<typeof executeWorkflowNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExecuteWorkflowNode<
  TData = Awaited<ReturnType<typeof executeWorkflowNode>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof executeWorkflowNode>>,
          TError,
          Awaited<ReturnType<typeof executeWorkflowNode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExecuteWorkflowNode<
  TData = Awaited<ReturnType<typeof executeWorkflowNode>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Execute Workflow Node
 */

export function useExecuteWorkflowNode<
  TData = Awaited<ReturnType<typeof executeWorkflowNode>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExecuteWorkflowNodeQueryOptions(
    executeWorkflowNodeRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Execute Workflow Node
 */
export const prefetchExecuteWorkflowNode = async <
  TData = Awaited<ReturnType<typeof executeWorkflowNode>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getExecuteWorkflowNodeQueryOptions(
    executeWorkflowNodeRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Execute Workflow Node
 */
export const executeWorkflowNodeMultipartFormData = (
  executeWorkflowNodeMultipartFormDataBody: ExecuteWorkflowNodeMultipartFormDataBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (executeWorkflowNodeMultipartFormDataBody.request !== undefined) {
    formData.append(
      `request`,
      JSON.stringify(executeWorkflowNodeMultipartFormDataBody.request),
    );
  }

  return executeFetch<ExecuteWorkflowNodeResponse>(
    {
      url: `/api/workflow/execute/node/multipart`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getExecuteWorkflowNodeMultipartFormDataMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeWorkflowNodeMultipartFormData>>,
    TError,
    { data: ExecuteWorkflowNodeMultipartFormDataBody },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof executeWorkflowNodeMultipartFormData>>,
  TError,
  { data: ExecuteWorkflowNodeMultipartFormDataBody },
  TContext
> => {
  const mutationKey = ["executeWorkflowNodeMultipartFormData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof executeWorkflowNodeMultipartFormData>>,
    { data: ExecuteWorkflowNodeMultipartFormDataBody }
  > = (props, context) => {
    const { data } = props ?? {};

    return executeWorkflowNodeMultipartFormData(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ExecuteWorkflowNodeMultipartFormDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof executeWorkflowNodeMultipartFormData>>
>;
export type ExecuteWorkflowNodeMultipartFormDataMutationBody =
  ExecuteWorkflowNodeMultipartFormDataBody;
export type ExecuteWorkflowNodeMultipartFormDataMutationError =
  ErrorType<unknown>;

/**
 * @summary Execute Workflow Node
 */
export const useExecuteWorkflowNodeMultipartFormData = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof executeWorkflowNodeMultipartFormData>>,
      TError,
      { data: ExecuteWorkflowNodeMultipartFormDataBody },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof executeWorkflowNodeMultipartFormData>>,
  TError,
  { data: ExecuteWorkflowNodeMultipartFormDataBody },
  TContext
> => {
  const mutationOptions =
    getExecuteWorkflowNodeMultipartFormDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save And Run Node Schema
 */
export const runGetSchema = (
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<ExecuteWorkflowNodeResponse>(
    {
      url: `/api/workflow/execute/node/rungetschema`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: executeWorkflowNodeRequest,
      signal,
    },
    options,
  );
};

export const getRunGetSchemaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runGetSchema>>,
    TError,
    { data: ExecuteWorkflowNodeRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runGetSchema>>,
  TError,
  { data: ExecuteWorkflowNodeRequest },
  TContext
> => {
  const mutationKey = ["runGetSchema"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runGetSchema>>,
    { data: ExecuteWorkflowNodeRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return runGetSchema(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type RunGetSchemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof runGetSchema>>
>;
export type RunGetSchemaMutationBody = ExecuteWorkflowNodeRequest;
export type RunGetSchemaMutationError = ErrorType<unknown>;

/**
 * @summary Save And Run Node Schema
 */
export const useRunGetSchema = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runGetSchema>>,
      TError,
      { data: ExecuteWorkflowNodeRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runGetSchema>>,
  TError,
  { data: ExecuteWorkflowNodeRequest },
  TContext
> => {
  const mutationOptions = getRunGetSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Execute Workflow Node Sse
 */
export const executeWorkflowNodeSse = (
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/workflow/execute/node/sse`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: executeWorkflowNodeRequest,
      signal,
    },
    options,
  );
};

export const getExecuteWorkflowNodeSseQueryKey = (
  executeWorkflowNodeRequest?: ExecuteWorkflowNodeRequest,
) => {
  return [
    `/api/workflow/execute/node/sse`,
    executeWorkflowNodeRequest,
  ] as const;
};

export const getExecuteWorkflowNodeSseQueryOptions = <
  TData = Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExecuteWorkflowNodeSseQueryKey(executeWorkflowNodeRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof executeWorkflowNodeSse>>
  > = ({ signal, meta }) =>
    executeWorkflowNodeSse(
      executeWorkflowNodeRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExecuteWorkflowNodeSseQueryResult = NonNullable<
  Awaited<ReturnType<typeof executeWorkflowNodeSse>>
>;
export type ExecuteWorkflowNodeSseQueryError = ErrorType<unknown>;

export function useExecuteWorkflowNodeSse<
  TData = Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
          TError,
          Awaited<ReturnType<typeof executeWorkflowNodeSse>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExecuteWorkflowNodeSse<
  TData = Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
          TError,
          Awaited<ReturnType<typeof executeWorkflowNodeSse>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExecuteWorkflowNodeSse<
  TData = Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Execute Workflow Node Sse
 */

export function useExecuteWorkflowNodeSse<
  TData = Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExecuteWorkflowNodeSseQueryOptions(
    executeWorkflowNodeRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Execute Workflow Node Sse
 */
export const prefetchExecuteWorkflowNodeSse = async <
  TData = Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodeSse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getExecuteWorkflowNodeSseQueryOptions(
    executeWorkflowNodeRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Execute Workflow Nodes
 */
export const executeWorkflowNodes = (
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest[],
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<ExecuteNodesResponse>(
    {
      url: `/api/workflow/execute/nodes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: executeWorkflowNodeRequest,
      signal,
    },
    options,
  );
};

export const getExecuteWorkflowNodesQueryKey = (
  executeWorkflowNodeRequest?: ExecuteWorkflowNodeRequest[],
) => {
  return [`/api/workflow/execute/nodes`, executeWorkflowNodeRequest] as const;
};

export const getExecuteWorkflowNodesQueryOptions = <
  TData = Awaited<ReturnType<typeof executeWorkflowNodes>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExecuteWorkflowNodesQueryKey(executeWorkflowNodeRequest);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof executeWorkflowNodes>>
  > = ({ signal, meta }) =>
    executeWorkflowNodes(
      executeWorkflowNodeRequest,
      { ...requestOptions, meta },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof executeWorkflowNodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExecuteWorkflowNodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof executeWorkflowNodes>>
>;
export type ExecuteWorkflowNodesQueryError = ErrorType<unknown>;

export function useExecuteWorkflowNodes<
  TData = Awaited<ReturnType<typeof executeWorkflowNodes>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest[],
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof executeWorkflowNodes>>,
          TError,
          Awaited<ReturnType<typeof executeWorkflowNodes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExecuteWorkflowNodes<
  TData = Awaited<ReturnType<typeof executeWorkflowNodes>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof executeWorkflowNodes>>,
          TError,
          Awaited<ReturnType<typeof executeWorkflowNodes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExecuteWorkflowNodes<
  TData = Awaited<ReturnType<typeof executeWorkflowNodes>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Execute Workflow Nodes
 */

export function useExecuteWorkflowNodes<
  TData = Awaited<ReturnType<typeof executeWorkflowNodes>>,
  TError = ErrorType<unknown>,
>(
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExecuteWorkflowNodesQueryOptions(
    executeWorkflowNodeRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Execute Workflow Nodes
 */
export const prefetchExecuteWorkflowNodes = async <
  TData = Awaited<ReturnType<typeof executeWorkflowNodes>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof executeWorkflowNodes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getExecuteWorkflowNodesQueryOptions(
    executeWorkflowNodeRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Re Trigger Execution
 */
export const reTriggerExecution = (
  repeatExecutionRequest: RepeatExecutionRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<ReTriggerExecution200>(
    {
      url: `/api/workflow/re-trigger-execution`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: repeatExecutionRequest,
      signal,
    },
    options,
  );
};

export const getReTriggerExecutionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reTriggerExecution>>,
    TError,
    { data: RepeatExecutionRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reTriggerExecution>>,
  TError,
  { data: RepeatExecutionRequest },
  TContext
> => {
  const mutationKey = ["reTriggerExecution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reTriggerExecution>>,
    { data: RepeatExecutionRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return reTriggerExecution(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ReTriggerExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof reTriggerExecution>>
>;
export type ReTriggerExecutionMutationBody = RepeatExecutionRequest;
export type ReTriggerExecutionMutationError = ErrorType<unknown>;

/**
 * @summary Re Trigger Execution
 */
export const useReTriggerExecution = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reTriggerExecution>>,
      TError,
      { data: RepeatExecutionRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reTriggerExecution>>,
  TError,
  { data: RepeatExecutionRequest },
  TContext
> => {
  const mutationOptions = getReTriggerExecutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @deprecated
 * @summary Trigger Workflow
 */
export const triggerWorkflow = (
  executeWorkflowRequest: ExecuteWorkflowRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<TriggerWorkflow200>(
    {
      url: `/api/workflow/trigger`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: executeWorkflowRequest,
      signal,
    },
    options,
  );
};

export const getTriggerWorkflowMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerWorkflow>>,
    TError,
    { data: ExecuteWorkflowRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerWorkflow>>,
  TError,
  { data: ExecuteWorkflowRequest },
  TContext
> => {
  const mutationKey = ["triggerWorkflow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerWorkflow>>,
    { data: ExecuteWorkflowRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return triggerWorkflow(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerWorkflow>>
>;
export type TriggerWorkflowMutationBody = ExecuteWorkflowRequest;
export type TriggerWorkflowMutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Trigger Workflow
 */
export const useTriggerWorkflow = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggerWorkflow>>,
      TError,
      { data: ExecuteWorkflowRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof triggerWorkflow>>,
  TError,
  { data: ExecuteWorkflowRequest },
  TContext
> => {
  const mutationOptions = getTriggerWorkflowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
